import React, { Component } from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FaGraduationCap, FaLaptopCode, FaHouseUser } from "react-icons/fa";




const Experience = () => {
    return (
        <div className='container mx-auto max-w-[1200px] p-3 overflow-hidden'>
            <div className="justify-between py-5 items-center">
                <div className='font-secondary text-center font-bold mb-12'>
                    <h4 className='text-secondary mb-3 text-[50px]'>Work Experience</h4>
                </div>
            </div>

            <div className='flex flex-col lg:flex-row items-start justify-between'>
                <VerticalTimeline>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="Mar 2025 - Now"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title font-weight: bold;"><strong>Sr. Technical System Analyst</strong> at <strong>PT Sinergi Informatika Semen Indonesia</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"> </h4> */}
                        {/* <p>
                            Development desktop apps internal of PT. KaryaIndah Alam Segar (Wings Group)
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="October 2024 - Mar 2025"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title font-weight: bold;"><strong>Sr. Software Engineer (.NET Developer)</strong> at <strong>PT KaryaIndah Alam Segar (Wings Group)</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"> </h4> */}
                        {/* <p>
                            Development desktop apps internal of PT. KaryaIndah Alam Segar (Wings Group)
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="December 2023 - Jun 2024"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Sr. System Analyst</strong> at <strong>PT Telkom Indonesia</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4> */}
                        {/* <p>
                            Analysist Business Requirement, Technical requirement use Brainstorming, Grooming,
                            Documentation SRS, NFT, Pentest, Domain Driven Design, API Contract, Use Case, Sequence Diagram
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="January 2023 - December 2023"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Lead ICT Engineer - System/Business Analyst</strong> at <strong>PT. Garuda Maintenance Facility (GMF) Aero Asia</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4> */}
                        {/* <p>
                            Documentation and Analyst (Blueprint, Business Requirement, User Acceptance Test, & Business Case),
                            UI/UX Designer
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="October 2022 - December 2022"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Sr. System Analyst, System Support & Front End Developer</strong> at <strong>RSUD. Dr. Soetomo Jawa Timur</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4> */}
                        {/* <p>
                            Documentation, Implementation Code, UI/UX Designer and analysis
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="February 2022 - August 2023"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Sr. Software (Engineer Web & Mobile)</strong> at <strong>PT. Patigeni Mitra Sejati</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4>
                        <p>
                            Implementation code for development website and mobile, and discuss business requirement
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--education"
                        date="January 2022"
                        iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                        icon={<FaGraduationCap />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Bachelor of Technology</strong> at <strong>Brawijaya University</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
                        <p>
                            Informatics Engineering
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="July 2019 - January 2022"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Jr. System Analyst & Software Engineer</strong> at <strong>CV. Pastiijadi Digital Solutions</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4>
                        <p>
                            Documentation,  UI/UX Designer, analysis and testing
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        className="vertical-timeline-element--work"
                        date="April 2019 - July 2022"
                        iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                        icon={<FaLaptopCode />}
                    >
                        <h3 className="vertical-timeline-element-title"><strong>Software Engineer Internship</strong> at<strong>PT. Avemedia Nusantara</strong></h3>
                        {/* <h4 className="vertical-timeline-element-subtitle"></h4>
                        <p>
                            Implementation code for development website and mobile, and discuss business requirement
                        </p> */}
                    </VerticalTimelineElement>
                    <VerticalTimelineElement
                        iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                        icon={<FaHouseUser />}
                    />
                </VerticalTimeline>

            </div>
        </div>
    )
}
export default Experience
